import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DropdownDataService {

  constructor() { }

  fillGenderValues() {
    return [
      { key: 'Male', value: 'Male' }, { key: 'Female', value: 'Female' }, { key: 'Third-Gender', value: 'Third-Gender' }
    ];
  }

  fillResidentialStatusValues() {
    return [
      { key: 'Resident-Indian', value: 'Resident Indian' },
      { key: 'Non-Resident-Indian', value: 'Non Resident Indian' }
    ];
  }

  fillMartialStatusValues() {
    return [
      { key: 'Single', value: 'Single' }, { key: 'Married', value: 'Married' }, { key: 'Separated', value: 'Separated' },
      { key: 'Divorced', value: 'Divorced' }, { key: 'Widowed', value: 'Widowed' }
    ];
  }

  fillOccupationStatusValues() {
    return [
      { key: 'Salaried', value: 'Salaried' }, { key: 'Self-Employed', value: 'Self Employed' },
      { key: 'Unemployed', value: 'Unemployed' }
    ];
  }

  fillIncomeOccupationStatusValues() {
    return [
      { key: 'SALARIED', value: 'Salaried' }, { key: 'SELF_EMPLOYED_PROFESSIONAL', value: 'Self Employed Professional' },
      { key: 'SELF_EMPLOYED_NONPROFESSIONAL', value: 'Self Employed NonProfessional' }
    ];
  }


  fillRelationshipPrimaryValues(type: string) {
    if (type == "Organisation") {
      return [
        { key: 'Director', value: 'Director' }, { key: 'Guardian', value: 'Guardian' }, { key: 'MD', value: 'MD' },
        { key: 'Partner', value: 'Partner' }, { key: 'Trustee', value: 'Trustee' }, { key: 'Karta', value: 'Karta' }
      ];
    }

    return [
      { key: 'Friend', value: 'Friend' }, { key: 'Parent', value: 'Parent' }, { key: 'Sibling', value: 'Sibling' },
      { key: 'Spouse', value: 'Spouse' }
    ];
  }


  fillBusinessTypeValues() {
    return [
      { key: 'Government', value: 'Government' }, { key: 'Others', value: 'Others' },
      { key: 'Partnership Firm', value: 'Partnership Firm' }, { key: 'Public Limited Company', value: 'Public Limited Company' },
      { key: 'Private Limited Company', value: 'Private Limited Company' },
      { key: 'Society', value: 'Society' }, { key: 'Trust', value: 'Trust' }
    ]
  }

  fillLongevityValues() {
    return [
      { key: '1', value: '< 6 Months' }, { key: '2', value: '6 Months to 1 Year' },
      { key: '3', value: '1 year to 2 Year' }, { key: '4', value: '> 2 years' }
    ]
  }

  fillLongevityValuesHN() {
    return [
      { key: '1', value: '6 महीने से कम' }, { key: '2', value: '6 महीने से 1 साल के बीच' },
      { key: '3', value: '1 से 2 साल के बीच' }, { key: '4', value: '2 साल से अधिक' }
    ]
  }

  fillSalariedOrgTypeValues() {
    return [
      { key: 'GOVT', value: 'Government' }, { key: 'OTH', value: 'Others' },
      { key: 'PTSHIP', value: 'Partnership Firm' }, { key: 'PUB_COM', value: 'Public Limited Company' },
      { key: 'PVT_COM', value: 'Private Limited Company' }, { key: 'SOCIETY', value: 'Society' },
      { key: 'TRUST', value: 'Trust' }
    ]
  }

  fillSalariedOrgTypeValuesHN() {
    return [
      { key: 'GOVT', value: 'सरकार' }, { key: 'OTH', value: 'अन्य' },
      { key: 'PTSHIP', value: 'साझेदारी फर्म' }, { key: 'PUB_COM', value: 'सीमित लोक समवाय' },
      { key: 'PVT_COM', value: 'प्राइवेट लिमिटेड कंपनी' }, { key: 'SOCIETY', value: 'समाज' },
      { key: 'TRUST', value: 'विश्वास' }
    ]
  }

  fillSelfEmpOrgTypeValues() {
    return [
      { key: 'DIRECT', value: 'Director' }, { key: 'OTH', value: 'Others' },
      { key: 'PARTNER', value: 'Partner' }, { key: 'PPSHIP', value: 'Proprietorship' },
      { key: 'TRUST', value: 'Trustee' }
    ]
  }

  fillSelfEmpOrgTypeValuesHN() {
    return [
      { key: 'DIRECT', value: 'निदेशक' }, { key: 'OTH', value: 'अन्य' },
      { key: 'PARTNER', value: 'साथी' }, { key: 'PPSHIP', value: 'स्वामित्व' },
      { key: 'TRUST', value: 'ट्रस्टी' }
    ]
  }

  fillTypeOfBusinessValues() {
    return [
      { key: 'MFG', value: 'Manufacturing' }, { key: 'SERVICE', value: 'Service' },
      { key: 'TRADING', value: 'Trading' }
    ]
  }

  fillTypeOfBusinessValuesHN() {
    return [
      { key: 'MFG', value: 'उत्पादन' }, { key: 'SERVICE', value: 'सेवा' },
      { key: 'TRADING', value: 'व्यापार' }
    ]
  }

  fillAbbToEmiValues() {
    return [
      { key: '1', value: 'Less than EMI' }, { key: '2', value: '1 to 2 times' },
      { key: '3', value: 'More than 2 times' }
    ]
  }

  fillBrands() {
    return [
      { key: 'Nissan', value: 'Nissan' }
    ];
  }

  fillModels() {
    return [
      { key: 'GO', value: 'Go' }
    ];
  }

  fillVariants() {
    return [
      { key: 'Repayment Variant 1', value: 'Repayment Variant 1' }
    ];
  }

}
